// src/components/ui/AlertMessage.jsx
import React, { useEffect, useState } from "react";

export const AlertMessage = ({ message, confirm }) => {
    const [visible, setVisible] = useState(!!message);

    useEffect(() => {
        if (message) {
            setVisible(true);

            const timer = setTimeout(() => {
                setVisible(false);
            }, 10000); // Hide after 5s

            return () => clearTimeout(timer);
        }
    }, [message]);

    if (!message || !visible) return null;

    return (
        <div
            className={`
        fixed top-5 left-1/2 transform -translate-x-1/2 z-50
        px-4 py-3 rounded-md shadow-md transition-all duration-500 ease-in-out
        ${confirm ? "bg-green-100 text-green-600" : "bg-red-100 text-red-600"}
        animate-slide-down
      `}
        >
            <p className="text-sm font-medium">{message}</p>
        </div>
    );
};
